const _temp0 = require("./images/swatches/abstract.svg");
const _temp1 = require("./images/swatches/balmoral.svg");
const _temp2 = require("./images/swatches/cove.svg");
const _temp3 = require("./images/swatches/dune.svg");
const _temp4 = require("./images/swatches/fluted.svg");
const _temp5 = require("./images/swatches/hamilton.svg");
const _temp6 = require("./images/swatches/haven.svg");
const _temp7 = require("./images/swatches/hayman.svg");
const _temp8 = require("./images/swatches/kimberly.svg");
const _temp9 = require("./images/swatches/oak.svg");
const _temp10 = require("./images/swatches/oyster.svg");
const _temp11 = require("./images/swatches/teak.svg");
const _temp12 = require("./images/swatches/timber.svg");
const _temp13 = require("./images/swatches/walnut.svg");
module.exports = {
  "abstract": _temp0,
  "balmoral": _temp1,
  "cove": _temp2,
  "dune": _temp3,
  "fluted": _temp4,
  "hamilton": _temp5,
  "haven": _temp6,
  "hayman": _temp7,
  "kimberly": _temp8,
  "oak": _temp9,
  "oyster": _temp10,
  "teak": _temp11,
  "timber": _temp12,
  "walnut": _temp13
}